import { Injectable } from '@angular/core';

import { Claim } from '@app-model/api';
import { ClaimsFilter, ClaimsFilterDateType, ClaimsFilterStatusType } from '@app-model/claims-filter';
import { ContractFilterDateType, ContractFilterStatusType } from '@app-model/history-filter';

import { SortingService } from './sorting.service';

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

@Injectable({
  providedIn: 'root',
})
export class ClaimService {
  static fetchClaimGroup(claims: Claim[]): ContractFilterDateType[] {
    return claims
      .reduce((acc, claim) => {
        const date = new Date(claim.dateOfLoss);
        const year = date.getFullYear();
        const month = date.getMonth();

        if (!acc.some((bucket) => bucket.year === year && bucket.month === month)) {
          acc.push({ year, month });
        }

        return acc;
      }, [])
      .sort((a, b) => (b.year - a.year ? b.year - a.year : b.month - a.month))
      .map((bucket) => new ContractFilterDateType(MONTH_NAMES[bucket.month] + ' ' + bucket.year));
  }

  static fetchStatus(contracts: Claim[]): ClaimsFilterStatusType[] {
    const status = contracts.reduce((prevVal, elem) => {
      // const statusName = this.getStatusName(elem.status);
      const index = prevVal.some((item) => {
        return item.name === elem.status;
      });

      if (!index) {
        prevVal.push(new ContractFilterStatusType(elem.status));
      }

      return prevVal;
    }, []);

    return SortingService.sortStrings<ClaimsFilterStatusType>(status);
  }

  static fetchClaimsFilters(claims: Claim[]): ClaimsFilter {
    if (claims) {
      const month: ClaimsFilterDateType[] = this.fetchClaimGroup(claims);
      const status: ClaimsFilterStatusType[] = this.fetchStatus(claims);

      return new ClaimsFilter(month, status);
    }
  }

  ////////// STATIC FILTER CONTRACTS ////////////////////////////////////////////////////////
  static filter(filters: ClaimsFilter, claims: Claim[]): Claim[] {
    let filteredClaims = this.filterByGroup(filters, claims);
    filteredClaims = this.filterByStatus(filters, filteredClaims);

    return filteredClaims;
  }

  static filterByGroup(claimsFilter: ClaimsFilter, claims: Claim[]): Claim[] {
    // get changed claims
    let allClaims = true;

    // Filter claims by claim month
    const filteredClaims = claims.filter((data) => {
      const index = claimsFilter.month.findIndex((x) => {
        const date = new Date(data.dateOfLoss);
        const year = date.getFullYear();
        const month = date.getMonth();
        const claimLabel = MONTH_NAMES[month] + ' ' + year;

        return x.name === claimLabel;
      });
      if (index > -1) {
        // uncheck allClaims button
        if (claimsFilter.month[index].selected) {
          allClaims = false;
        }

        return claimsFilter.month[index].selected;
      } else {
        return true;
      }
    });

    if (allClaims) {
      return claims;
    }

    return filteredClaims;
  }

  static filterByStatus(claimsFilter: ClaimsFilter, claims: Claim[]): Claim[] {
    // get changed product filters
    let allClaims = true;

    // reset term filter display
    claimsFilter.status.forEach((_, index: number) => {
      claimsFilter.status[index].display = false;
    });

    // Filter products by status
    const filteredClaims = claims.filter((data) => {
      //  const statusName = this.getStatusName(data.status);
      const index = claimsFilter.status.findIndex((x) => x.name === data.status);
      if (index > -1) {
        // uncheck allProduct button
        if (claimsFilter.status.some(({ selected }) => selected)) {
          allClaims = false;
        }
        claimsFilter.status[index].display = true;

        return claimsFilter.status[index].selected;
      } else {
        return true;
      }
    });

    if (allClaims) {
      return claims;
    }

    return filteredClaims;
  }
}
